// extracted by mini-css-extract-plugin
export default {"wrapper":"MicrositeDisplay_wrapper__ZPppQ","container":"MicrositeDisplay_container__TEMmr"};